import { ENTITY_CONFIGS } from '../config';
import { Entity } from './types';

export const getEntityConfig = (entity: Entity) => {
  return ENTITY_CONFIGS[entity];
};
